import React, { useState } from "react";
import {
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  OutlinedInput,
} from "@mui/material";

const FilterChips = ({
  options = [],
  selectedValues = [],
  onChange,
  label = "Select States",
  placeholder = "Choose states...",
  multiple = true,
}) => {
  const handleDelete = (valueToDelete) => {
    const newValues = selectedValues.filter((value) => value !== valueToDelete);
    onChange(newValues);
  };

  const handleChange = (event) => {
    const value = event.target.value;
    onChange(value);
  };

  return (
    <Box>
      <FormControl fullWidth margin="normal">
        <InputLabel id="filter-chips-label">{label}</InputLabel>
        <Select
          labelId="filter-chips-label"
          multiple={multiple}
          value={selectedValues}
          onChange={handleChange}
          input={<OutlinedInput label={label} />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => (
                <Chip
                  key={value}
                  label={value}
                  onDelete={() => handleDelete(value)}
                  size="small"
                  color="primary"
                  sx={{
                    backgroundColor: "#f5f5f5",
                    color: "gray",
                    borderColor: "#e0e0e0",
                    "&:hover": {
                      backgroundColor: "#eeeeee",
                    },
                    "& .MuiChip-deleteIcon": {
                      color: "#666666",
                      "&:hover": {
                        color: "gray",
                      },
                    },
                  }}
                />
              ))}
            </Box>
          )}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value || option}
              value={option.value || option}
            >
              {option.label || option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedValues.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
          {selectedValues.map((value) => (
            <Chip
              key={value}
              label={value}
              onDelete={() => handleDelete(value)}
              color="primary"
              variant="outlined"
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default FilterChips;
